import { SuperAdminConstants } from '../../../_constants';

const initialState = { getReviewQuestionsLoading: true, data: '', error: false };

export function getReviewQuestionsReducer(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_REVIEW_QUESTIONS:
            return {
                getReviewQuestionsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_REVIEW_QUESTIONS:
            return {
                getReviewQuestionsLoading: false,
                data: action.getReviewQuestions,
                error: false
            };
        case SuperAdminConstants.GET_REVIEW_QUESTIONS_ERROR:
            return {
                getReviewQuestionsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ReviewQuestions/getReviewQuestions.reducer.js